
/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

import axios from '../../../utils/axios';
import { dispatch } from '../../index';
import { handleError, handleSuccess } from '../../../utils/apiResponseHandler.js';

const initialState = {
    error: null,
    phoneNumbers: null,
    singlePhoneNumber: null,
    loading: false,
    saveLoading: false,
    totalPages: null,
    totalCount: null,
};

const slice = createSlice({
    name: 'adminPhoneNumber',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        isLoading(state, action) {
            state.loading = action.payload;
        },

        isSaveLoading(state, action) {
            state.saveLoading = action.payload;
        },

        setPhoneNumberDataSuccess(state, action) {
            state.phoneNumbers = action.payload?.data;
            state.totalCount = action.payload?.totalCount;
            state.totalPages = action.payload?.totalPages;
        },

        setSinglePhoneNumberDataSuccess(state, action) {
            state.singlePhoneNumber = action.payload;
        },

        updatePhoneNumberDataSuccess(state, action) {
            const index = state.phoneNumbers.findIndex(phoneNumber => phoneNumber._id === action.payload.id);
            const phoneNumberData = state.phoneNumbers[index];
            const newData = { ...phoneNumberData, ...action.payload.data };
            state.phoneNumbers[index] = newData
        },

        createPhoneNumberDataSuccess(state, action) {
            state.phoneNumbers.push(action.payload);
        },

        deletePhoneNumberDataSuccess(state, action) {
            const newPhoneNumbers = state.phoneNumbers.filter(phoneNumber => phoneNumber._id !== action.payload.id);
            state.phoneNumbers = newPhoneNumbers;
        },

    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getAllPhoneNumbers({ page, limit, search }) {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true))

            const response = await axios.get(`/admin/numbers?search=${search}&page=${page}&limit=${limit}`);
            dispatch(slice.actions.setPhoneNumberDataSuccess(response?.data))

            return response?.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false))
        }
    }
}
export function getSinglePhoneNumber({ id }) {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true))

            const response = await axios.get(`/admin/numbers/${id}`);
            dispatch(slice.actions.setSinglePhoneNumberDataSuccess(response?.data))

            return response?.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false))
        }
    }
}

export function createPhoneNumber(data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveLoading(true))

            const response = await axios.post(`/admin/numbers`, data);
            dispatch(slice.actions.createPhoneNumberDataSuccess(response.data))

            handleSuccess(response, "Phone Number created successfully", dispatch);

            return response.data;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
        finally {
            dispatch(slice.actions.isSaveLoading(false))
        }
    }
}

export function updatePhoneNumber(id, data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveLoading(true))

            const response = await axios.put(`/admin/numbers/${id}`, data);

            dispatch(slice.actions.updatePhoneNumberDataSuccess(
                { data, id }
            ))
            handleSuccess(response, "Phone Number updated successfully", dispatch);

            return response.data;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
        finally {
            dispatch(slice.actions.isSaveLoading(false))
        }
    }
}

export function deletePhoneNumber(id) {
    return async () => {
        try {
            const response = await axios.delete(`/admin/numbers/${id}`);
            dispatch(slice.actions.deletePhoneNumberDataSuccess(
                { id }
            ))
            handleSuccess(response, "Phone Number deleted successfully", dispatch);

            return response.data?.message;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
    }
}
